module.exports = __webpack_public_path__ + "img/work-order.cc25a97c.svg";